<div class="titulo">
    <p><span>2. </span>Preencha seus dados</p>
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="fill">
        <mat-label>Nome</mat-label>
        <input name="firstname" appOnlyLetters formControlName="name" type="text" matInput required
               autocomplete="off">
        <mat-error *ngIf="form.controls.name.hasError('required')">Campo obrigatório</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Primeiro sobrenome</mat-label>
        <input name="lastname" appOnlyLetters formControlName="lastName" type="text" matInput required
               autocomplete="off">
        <mat-error *ngIf="form.controls.lastName.hasError('required')">Campo obrigatório
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Segundo sobrenome</mat-label>
        <input appOnlyLetters formControlName="secondLastName" type="text" matInput
               autocomplete="off">
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>E-mail</mat-label>
        <input name="email" appToLowercase formControlName="email" type="text" matInput required
               autocomplete="off">
        <mat-error *ngIf="form.controls.email.hasError('required')">Campo obrigatório
        </mat-error>
        <mat-error
                *ngIf="!form.controls.email.hasError('required') && form.controls.email.hasError('emailFormat')">
            E-mail inválido
        </mat-error>
    </mat-form-field>
    <mat-radio-group [formControl]="tipoCuenta" required>
        <label> <strong>Como você planeja usar o FAD®?</strong></label>
        <mat-radio-button [value]="false">Para acordos pessoais?</mat-radio-button>
        <mat-radio-button [value]="true">Para acordos da minha empresa?</mat-radio-button>
    </mat-radio-group>
    <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}">
        Aceito os <a
            [routerLink]="['/termos-e-condicoes']" target="_blank">Termos e Condições</a>, bem como a
        <a [routerLink]="['/aviso-de-privacidade']" target="_blank">Política de Privacidade</a>
    </mat-checkbox>
    <button *ngIf="valid" class="submit-button" type="submit">
        <p>CREAR CUENTA</p>
    </button>
    <button class="submit-button" [disabled]="form.invalid || !acepptTerms" [ngClass]="{'disabled':form.invalid  || !acepptTerms }">
        <p>CREAR CUENTA</p>
    </button>
</form>
